import React, { lazy, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { OfferViewContext, OfferViewType } from 'context/offerViewContext';
import { showVerticalGalleryOverlay } from 'modules/overlay/actions';
import { getVerticalGalleryOverlayVisibility } from 'modules/overlay/selectors';
import { Hotel } from 'modules/sapiSearch/slice';
import { imageProvider as defaultImageProvider } from 'utils/imageProvider';
import { Icon } from '@daedalus/atlas/Icon';
import { Image } from '@daedalus/atlas/Image';
import { Tag } from '@daedalus/atlas/Tag';
import { useDispatchTeamEvent } from '@daedalus/core/src/analytics/components/TeamContext';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { ImageProvider } from '@daedalus/core/src/staticContent/types/ImageProvider';
import { MAX_IMAGES, MOSAIC_FIRST_ROW_ID } from './constants';
interface Props {
  images: string[];
  hotelId: Hotel['objectID'];
  imageUrlProvider?: ImageProvider;
}
const Layout = /*#__PURE__*/styled('div')({
  name: "Layout",
  class: "lnpkem9",
  propsAsIs: false
});
const VerticalGalleryBottomSheet = lazy(() => import( /* webpackChunkName: "VerticalGalleryBottomSheet" */
/* webpackPrefetch: true */
'./VerticalGalleryBottomSheet'));
const Gallery = /*#__PURE__*/styled('div')({
  name: "Gallery",
  class: "g6o0r4o",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => Tag;
const MoreImageTag = /*#__PURE__*/styled(_exp3())({
  name: "MoreImageTag",
  class: "m1q2scao",
  propsAsIs: true
});
export const MosaicGallery = ({
  imageUrlProvider = defaultImageProvider,
  hotelId,
  images
}: Props) => {
  const dispatch = useDispatch();
  const dispatchTeamEvent = useDispatchTeamEvent();
  const isOpen = useSelector(getVerticalGalleryOverlayVisibility);
  const imagesSliced = images.slice(0, MAX_IMAGES);
  const onClickImageHandler = () => {
    dispatchTeamEvent(trackEvent({
      category: Category.User,
      entity: Entity.HotelDetailsGallery,
      action: Action.Clicked
    }));
    dispatch(showVerticalGalleryOverlay());
  };
  return <Gallery>
      <MoreImageTag size="md" iconStart={<Icon size="sm" name="Photo" />}>
        {images.length}
      </MoreImageTag>
      <Layout data-layout={imagesSliced.length}>
        {imagesSliced.map((image, index) =>
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus
      <div key={image} role="button" data-id={`gallery-${index}`} {...index === 0 && {
        id: MOSAIC_FIRST_ROW_ID
      }} onClick={onClickImageHandler}>
            <Image hasSkeletonLoader isResponsive imageProvider={imageUrlProvider} size="gridPrimary" url={image} />
          </div>)}
      </Layout>
      <OfferViewContext.Provider value={OfferViewType.AP_DETAILS_OVERLAY}>
        {isOpen && <Suspense fallback={null}>
            <VerticalGalleryBottomSheet isOpen={isOpen} images={images} hotelId={hotelId} />
          </Suspense>}
      </OfferViewContext.Provider>
    </Gallery>;
};

require("./MosaicGallery.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MosaicGallery.tsx");